// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608260404/js/" + chunkId + "." + {"44":"db4cbe6f","225":"e910ddea","481":"129a43af","486":"cb7dcbea","770":"b8c2e275"}[chunkId] + ".0.7160439203151261.chunk.js";
};